// extracted by mini-css-extract-plugin
module.exports = {"button":"slideControls-module--button--2HaPM","back":"slideControls-module--back--2bNRD","skip":"slideControls-module--skip--utcIy"};